module.exports = __webpack_public_path__ + "static/media/wizualizacja-81.85fe70f0.png";